import { proxy } from 'valtio';

import type { CompanyProfile } from 'models';

const currentTeamCompaniesState = proxy<{
    companies: CompanyProfile[];
}>({
    companies: [],
});

export { currentTeamCompaniesState };
